import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import {
  SnackbarProvider,
  MaterialDesignContent,
  closeSnackbar,
} from 'notistack';
import { ColorButton } from '@fuww/library/src/Button';
import colors from '@fuww/library/src/Theme/colors';
import blue from '@fuww/library/src/Palettes/blue';

const SnackbarMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: colors.success,
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: colors.error,
  },
  '&.notistack-MuiContent-info': {
    backgroundColor: blue[800],
  },
}));

const action = (snackbarId: number | string) => (
  <ColorButton
    name="error"
    variant="contained"
    onClick={() => closeSnackbar(snackbarId)}
    palette={{
      600: 'rgba(0, 0, 0, 0.1)',
      700: 'rgba(0, 0, 0, 0.2)',
    }}
  >
    OK
  </ColorButton>
);

const NotificationsProvider = ({
  children,
  autoHideDuration,
}: ComponentProperties & { autoHideDuration?: number | null }) => (
  <SnackbarProvider
    anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
    autoHideDuration={autoHideDuration ?? 10_000}
    variant="success"
    Components={{
      success: SnackbarMaterialDesignContent,
      error: SnackbarMaterialDesignContent,
      info: SnackbarMaterialDesignContent,
    }}
    action={action}
  >
    {children}
  </SnackbarProvider>
);

NotificationsProvider.propTypes = {
  children: PropTypes.node,
  autoHideDuration: PropTypes.number,
};

export default NotificationsProvider;
